var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPosilki = function SvgPosilki(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st16{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M22.8,5.1L18.9,9c-1.1,1.1-2.8,1.1-3.9,0s-1.1-2.8,0-3.9l3.9-3.9L17.7,0l-3.9,3.9c-0.8,0.8-1.3,2-1.3,3.1 s0.5,2.3,1.3,3.1s2,1.3,3.1,1.3c1.2,0,2.3-0.5,3.1-1.3l4-3.8L22.8,5.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.689 10.9246)",
    className: "st16",
    width: 0.6,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 6,
    transform: "matrix(0.7058 -0.7084 0.7084 0.7058 0.1946 14.1692)",
    className: "st16",
    width: 10.5,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.7,13.6L5,0.9C4.7,0.6,4.4,0.6,4.2,0.6C3.9,0.7,3.6,0.9,3.6,1.2L2.4,4.7C1.9,6.5,2.3,8.5,3.7,9.8l8.9,8.9 c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2l3.9-3.9c0.2-0.2,0.2-0.4,0.2-0.6C17.9,13.9,17.8,13.7,17.7,13.6z M13.2,16.9 L4.9,8.6C4,7.7,3.7,6.4,4,5.2L4.7,3l11.2,11.1L13.2,16.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M23.7,19.6l-6.2-6.2l-1.2,1.2l5.6,5.6L21,21.1l-5.4-5.4l-1.2,1.2l6,6c0.2,0.2,0.4,0.2,0.6,0.2 s0.4-0.1,0.6-0.2l2.1-2.1C24,20.4,24,19.9,23.7,19.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M10.7,15.4l-2.1-2.1c-0.3-0.3-0.9-0.3-1.2,0l-7.2,7.2C0.1,20.6,0,20.8,0,21s0.1,0.4,0.2,0.6l2.1,2.1 C2.5,23.9,2.8,24,3,24s0.4-0.1,0.6-0.2l7.2-7.2C11,16.4,11,16.2,11,16C11,15.8,10.9,15.5,10.7,15.4z M3,22l-1-1l6-6l0.9,1L3,22z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPosilki, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/posilki.6031325e.svg";
export { ForwardRef as ReactComponent };